const g = (o, c = "log") => {
  console[c](
    "%c IDS ",
    "background: #21F5A8; color: #3A1C46; font-weight:bold;",
    o
  );
};
export {
  g as idsLogger
};
